<template>
    <table class="stage-list">
        <thead class="stage-list__thead">
        <tr>
            <td class="stage__col stage__col_name">Этапы</td>
            <td class="stage__col stage__col_related">Предэтапы</td>
            <td class="stage__col stage__col_responsible">Ответственный</td>
            <td class="stage__col stage__col_date-start">Старт</td>
            <td class="stage__col stage__col_date-finish">Финиш</td>
            <td class="stage__col stage__col_status">Статус</td>
        </tr>
        </thead>

        <tbody class="stage-list__tbody">
            <slot></slot>
        </tbody>
    </table>
</template>

<script>
export default {
    name: "StageListTable"
}
</script>

<style lang="scss">
@import "/resources/common/scss/abstracts/abstracts";

.stage-list {
    width: 100%;
    margin: 0 -8px;

    &, &__thead, &__tbody, &__tfoot {
        display: block;
    }

    &, &__thead {
        position: relative;

        &::before {
            content: '';
            position: absolute;
            top: 100%;
            left: 8px;
            right: 8px;
            border-bottom: 1px solid $secondary;
        }
    }

    &__thead, tbody {
        .stage__col {
            padding: 6px 8px;
        }
    }

    &__thead {
        font-family: $headings-font-family;
        font-weight: 700;
        font-size: 18px;
        line-height: 22px;
        text-transform: uppercase;
        color: #000000;
    }

    &__thead, &__tbody, &__tfoot {
        > tr {
            display: flex;
        }
    }

    tr {
        &:first-child {
            padding-top: 6px;
        }

        &:last-child {
            padding-bottom: 6px;
        }

        .stage__col {
            position: relative;
            flex: 0 0 auto;

            .form-input {
                width: 100%;
            }

            .dropdown__body {
                min-width: 180px;
            }

            .mx-datepicker-inline {
                z-index: 100;
                position: absolute;
                top: 40px;
                left: 0;
            }
        }

        .stage__col_name {
            width: 20%;

            @media screen and (max-width: 1600px) {
                max-width: 180px;
            }
        }

        .stage__col_related {
            width: 16%;

            @media screen and (max-width: 1600px) {
                max-width: 160px;
            }
        }

        .stage__col_responsible {
            width: 20%;

            @media screen and (max-width: 1600px) {
                max-width: 170px;
            }

            .dropdown__body {
                min-width: 225px;
            }
        }

        .stage__col_date-start,
        .stage__col_date-finish {
            width: 16%;
            text-align: center;
        }

        .stage__col_status {
            width: 12%;
        }
    }
}
</style>
